import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { TranslateService } from "@app/modules/shared/services/translate/translate.service";
import { ApiService } from "@app/modules/shared/services/base/api.service";
import { AuthService } from "@app/modules/shared/services/auth.service";
import {
  ExplorerService,
  TabConfig,
} from "@app/modules/shared/services/explorer.service";
import { CurrencyComponent } from "@dashboard/components/currency/currency.component";
import { DynamicComponent } from "@app/data/dashboard/interfaces/dynamic-component.interface";
import { UtilService } from "@app/modules/shared/services/util.service";
import { KlSweetAlertService } from "@app/modules/shared/services/message/kl-sweet-alert.service";
import { Subscription } from "rxjs/Subscription";

declare var moment;

@Component({
  selector: "kl-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})
export class SidebarComponent implements OnInit, OnDestroy {
  @Input() showSidebar = false;
  @Output() onHideSidebar = new EventEmitter<any>();
  language: any;
  userProfile: any;
  changePass = {
    current_password: "",
    new_password: "",
    new_password_confirmation: "",
  };
  alertShow: boolean;
  alertMessage: string;
  alertType: string;
  serverSuccess: boolean;
  serverError: boolean;
  errorShow: boolean;
  passwordNotSame: boolean;
  subscription: Subscription;

  constructor(
    private el: ElementRef,
    private _translate: TranslateService,
    private utilService: UtilService,
    private klSweetAlert: KlSweetAlertService,
    private explorerService: ExplorerService,
    private authService: AuthService,
    private apiService: ApiService
  ) {
    this.subscription = explorerService.userStream$.subscribe((response) => {
      this.userProfile = response;
    });
  }

  ngOnInit() {
    this.language = localStorage.getItem("currentLanguage");
    this.selectLang(this.language);
  }

  selectLang(language: string) {
    this._translate.useCulture(language);
    this._translate.use(language);
    this.explorerService.menuCollapse();
    this.explorerService.setLanguage(language);
    moment.locale(language + "-" + language.toUpperCase());
    localStorage.setItem(
      "dateFormatString",
      moment.localeData().longDateFormat("L")
    );
    sessionStorage.setItem(
      "dateFormatString",
      moment.localeData().longDateFormat("L")
    );
    document.getElementsByTagName("html")[0].setAttribute("lang", language);
    if (
      language !== "fa" &&
      document.getElementsByTagName("html")[0].hasAttribute("dir")
    ) {
      document.getElementsByTagName("html")[0].removeAttribute("dir");
    } else if (
      language === "fa" &&
      !document.getElementsByTagName("html")[0].hasAttribute("dir")
    ) {
      document.getElementsByTagName("html")[0].setAttribute("dir", "rtl");
    }
  }

  openTab() {
    const tabConfig = <TabConfig>{
      id: "currency",
      title: "exchange",
      isCloseable: true,
      childTemplate: <DynamicComponent>{
        mode: "list",
        template: CurrencyComponent,
      },
    };
    this.explorerService.openTab(tabConfig);
  }

  inputChange() {
    this.serverError = false;
    this.errorShow = false;
    this.serverSuccess = false;
    this.passwordNotSame = false;
  }

  changePassword() {
    if (
      this.changePass.new_password_confirmation === this.changePass.new_password
    ) {
      const changed = {
        old_password: this.changePass.current_password,
        new_password: this.changePass.new_password,
        user_name: this.userProfile.username,
      };
      this.apiService.changePassword(changed).subscribe(
        () => {
          this.changePass = {
            current_password: "",
            new_password: "",
            new_password_confirmation: "",
          };
          this.alertShow = true;
          this.alertType = "success";
          this.alertMessage = "password_change_success_message";
        },
        (errChange) => {
          this.alertShow = true;
          this.alertType = "error";
          this.alertMessage = this.utilService.alertErrorMessage(errChange);
        }
      );
    } else {
      this.alertShow = true;
      this.alertType = "error";
      this.alertMessage = "password_not_same";
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  closeSidebar() {
    this.showSidebar = false;
    this.onHideSidebar.emit();
  }
}
